import {
    getArchivedVacancyHH,
    getCurrentUserHH,
    getFavorite,
    getVacancyById,
    getVacancyHH,
    getVacancyResponses
} from "./vacancy";
import {authRedirect, getToken, refreshToken} from "./auth";
import {loadGroupFiles} from "./load-files";

export const hhApi = {

// auth
    getToken,
    refreshToken,
    authRedirect,

//user
    getCurrentUserHH,

    //vacancy
    getVacancyHH,
    getArchivedVacancyHH,
    getVacancyById,
    getVacancyResponses,
    getFavorite,


    loadGroupFiles
}